export const PHONE_COMMUNICATION_TYPE_INFO_TEXT_MAP = {
  MESSAGE: 'Checking this box indicates your client has agreed to receive messages at this number.',
  NOTIFICATION: 'Checking this box enables notifications to your client about the status of their referrals.',
};

export const EMAIL_COMMUNICATION_TYPE_INFO_TEXT_MAP = {
  MESSAGE: 'Checking this box indicates your client has agreed to receive messages at this email address.',
  NOTIFICATION: 'Checking this box enables automated notifications to your client at this email address about the status of their referrals.', // eslint-disable-line max-len
};
